import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { DialogMessage } from './Widgets/DialogMessage';
import './VehicleReservations/css/vehicleReservations.css';

class VehicleReservations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            isErrorMessage: false,
            errorMessage: "",
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: false,
            reservationId: props.match.params.id,
            reservationDetails: {},
            showLockboxCode: false,
            lockboxCode: "",
            dropOffTime: ""
        };
        this.getReservationDetails = this.getReservationDetails.bind(this);
        this.markReservationTimeStamp = this.markReservationTimeStamp.bind(this);
        this.readyToDropoff = this.readyToDropoff.bind(this);
    }

    componentDidMount() {
        this.getReservationDetails();
    }

    async getReservationDetails() {
        const { reservationId } = this.state;
        if (!reservationId) return;

        await this.props.makeRESTCall(
            `byuvehiclereservations?reservationId=${reservationId}`,
            'get',
            null,
            (res) => {
                if (res.success) {
                    this.setState({ reservationDetails: res.reservationDetails });
                } else {
                    this.setState({
                        errorMessage: res.message || "Failed to load reservation details."
                    });

                }
            },
            (title, error) => {
                const message = error.message === "Failed to fetch"
                    ? "Network error. Check your internet connection."
                    : error.toString();
                this.setState({
                    errorMessage: message || "There was a network error."
                });
            },
            () => { }
        );
    }

    showLockboxCode(dropoff, skipCheck) {
        if (skipCheck || window.confirm(`Select OK to confirm you are at the lockbox to ${dropoff ? 'drop off' : 'pick up'} the keys.`)){
            const { reservationDetails } = this.state;
            const code = dropoff
                ? `Your lockbox dropoff code is ${reservationDetails.lockbox_code_dropoff}`
                : `Your lockbox pickup code is ${reservationDetails.lockbox_code_pickup}`;
            const returnTime = dropoff
                ? ''
                : reservationDetails.drop_off_time
                    ? `Please return the vehicle by ${reservationDetails.drop_off_time}. You will receive another code to place the keys back inside the lockbox.`
                    : '';

            this.setState({
                showLockboxCode: true,
                lockboxCode: code,
                dropOffTime: returnTime
            });

            this.markReservationTimeStamp(dropoff);
        }
    }

    async markReservationTimeStamp(dropoff) {
        const { reservationId } = this.state;

        await this.props.makeRESTCall(
            'byuvehiclereservations',
            'put',
            { dropoff, reservationId },
            () => {
                let reservationDetails = this.state.reservationDetails;
                const now = new Date().toISOString();
                if (dropoff) {
                    reservationDetails.dropped_off_time = now;
                } else {
                    reservationDetails.picked_up_time = now;
                }
            },
            (title, error) => {
                const message = error.message === "Failed to fetch"
                    ? "Network error. Check your internet connection."
                    : error.toString();
                this.setState({
                    errorMessage: message || "There was a network error."
                });
            },
            () => { }
        );
    }

    async readyToDropoff() {
        if (window.confirm("Select OK to confirm you are at the lockbox to drop off the keys.")) {
            if (this.state.reservationDetails.lockbox_code_dropoff) {
                this.showLockboxCode(true, true);
            }
            else {
                this.setState({ loading: true });
                const putBody = {
                    dropoff:true,
                    reservationId: this.state.reservationId
                };
                await this.props.makeRESTCall(
                    'byuvehiclereservations',
                    'put',
                    putBody,
                    (getDropoffCodeResponse) => {
                        if (getDropoffCodeResponse.success) {
                            let reservationDetails = this.state.reservationDetails;
                            reservationDetails.lockbox_code_dropoff = getDropoffCodeResponse.lockbox_code_dropoff;
                            reservationDetails.dropped_off_time = getDropoffCodeResponse.dropped_off_time;
                            this.setState({
                                reservationDetails: reservationDetails
                            })
                            this.showLockboxCode(true, true);
                        }
                        else {
                            alert(getDropoffCodeResponse.message || "There was an error getting the dropoff code. Please contact BYU IT for help.");
                        }
                    },
                    (title, error) => {
                        const message = error.message === "Failed to fetch"
                            ? "Network error. Check your internet connection."
                            : error.toString();
                        this.setState({
                            errorMessage: message || "There was a network error."
                        });
                    },
                    () => {
                        this.setState({ loading: false });
                    }
                );
            }
        }
    }

    renderContent() {
        const {
            reservationDetails,
            showLockboxCode,
            lockboxCode,
            dropOffTime,
            errorMessage
        } = this.state;

        const now = new Date();
        const reservationEndTime = new Date(reservationDetails.end_time);

        if (errorMessage) {
            return <p className="vr-message vr-error">{errorMessage}</p>;
        }
        if (!reservationDetails.picked_up_time && reservationEndTime < now) {
            return <p className="vr-message vr-warning">Your reservation has expired. Please make a new one if needed.</p>;
        }

        if (!reservationDetails.lockbox_code_pickup) {
            return <p className="vr-message">Your reservation is not yet ready. Please check closer to your pickup time.</p>;
        }

        if (showLockboxCode) {
            return (
                <div className="vr-message vr-code">
                    <p>{lockboxCode}</p>
                    {dropOffTime && <p>{dropOffTime}</p>}
                    <br/>
                    <p>To unlock the keybox, press and hold '5' until every number lights up. Enter your code then click the unlock symbol (Bottom Right)</p>
                    {
                        dropOffTime && <div className="vr-button-group">
                            <button className="vr-action-button" onClick={() => this.readyToDropoff()}>Ready to Dropoff</button>
                        </div>
                    }
                </div>
            );
        }

        if (reservationDetails.dropped_off_time) {
            return (
                <>
                    <p className="vr-message vr-success">
                        The vehicle was returned at {reservationDetails.dropped_off_time}. Thank you!
                    </p>
                    <div className="vr-button-group">
                        <button className="vr-action-button" onClick={() => this.showLockboxCode(true, true)}>See Drop Off Code</button>
                    </div>
                </>
               
            );
        }


        return (
            <div className="vr-button-group">
                {
                    reservationDetails.picked_up_time ? (
                        <>
                            <button className="vr-action-button" onClick={() => this.showLockboxCode(false, true)}>See Pickup Code</button>
                            <br />
                            {
                                reservationDetails.lockbox_code_dropoff ?
                                    <button className="vr-action-button" onClick={() => this.showLockboxCode(true)}>Drop Off</button>
                                    : <button className="vr-action-button" onClick={() => this.readyToDropoff()}>Ready to Dropoff</button>

                            }
                        </>
                    ) : (
                        <button className="vr-action-button" onClick={() => this.showLockboxCode(false)}>Pick Up</button>
                    )
                }
            </div>
        );
    }

    render() {
        const { reservationId, reservationDetails } = this.state;

        if (!reservationId) {
            return <p className="vr-message vr-error">Invalid link. Please contact BYU IT for help.</p>;
        }

        return (
            <div className="vr-container">
                <h2 className="vr-title">Vehicle Reservation for {reservationDetails.vehicle}</h2>
                {
                    (Object.keys(reservationDetails).length === 0 || this.state.loading) && !this.state.errorMessage
                        ? <p className="vr-message">Loading...</p>
                        : this.renderContent()
                }

                <DialogMessage
                    open={this.state.showDialog}
                    title={this.state.dialogTitle}
                    content={this.state.dialogContent}
                    isError={this.state.isErrorMessage}
                    onClose={() => this.setState({ showDialog: false })}
                />
            </div>
        );
    }
}

export default withRouter(VehicleReservations);
